import { FolderSearch, X } from "lucide-react";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { Button } from "@libs/zapi-ui/ds/components/button";

type TProps = {
  onClearAll: () => void;
};

export function NoProjectsFoundState({ onClearAll }: TProps) {
  return (
    <div
      data-testid="no-projects-found"
      className="flex flex-1 flex-col items-center justify-center gap-[22px] bg-innoveraZinc-100 px-5 py-12"
    >
      <div className="flex flex-col items-center gap-2">
        <FolderSearch className="h-[52px] w-[52px] text-innoveraZinc-300" strokeWidth={1.5} />
        <div className="flex flex-col items-center gap-1">
          <FigmaTypography variant="heading-3" color="zinc900">
            No projects found
          </FigmaTypography>
          <FigmaTypography variant="body-2" color="zinc500" className="w-[244px] text-center">
            Try adjusting your search or filters.
          </FigmaTypography>
        </div>
      </div>
      <Button type="button" variant="outline" data-testid="no-projects-found-clear-all-button" onClick={onClearAll}>
        <X className="h-4 w-4" />
        Clear all
      </Button>
    </div>
  );
}
